"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateAccountAnchorWrapper = exports.BelowCTAMessageContainer = exports.PLBBuyButtonContainer = exports.PLBFullWidthButton = exports.PLBBoxDescriptionContainer = exports.PLBBoxTitleContainer = exports.PLBBoxContainerWrapper = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const themed_button_1 = require("../themed-button");
exports.PLBBoxContainerWrapper = styled_components_1.default.div `
  display: flex;
  flex: 1;
  flex-direction: column;
  width: 100%;
`;
exports.PLBBoxTitleContainer = styled_components_1.default.div `
  padding: 10px 0 20px 0;
`;
exports.PLBBoxDescriptionContainer = styled_components_1.default.div `
  margin-bottom: 10px;
`;
exports.PLBFullWidthButton = (0, styled_components_1.default)(themed_button_1.ThemedButton) `
  width: 100%;
  height: 45px;
  font-size: 16px;
  line-height: 21px;
  margin-bottom: 14px;
  cursor: pointer;
`;
exports.PLBBuyButtonContainer = styled_components_1.default.div `
  margin: ${(props) => props.theme.spacings.mediumPlus} 0 0 0;
`;
exports.BelowCTAMessageContainer = styled_components_1.default.div `
  margin-bottom: 10px;
`;
exports.CreateAccountAnchorWrapper = styled_components_1.default.div `
  display: inline;
  cursor: pointer;
`;
